import { CarouselContent, CarouselItem } from "../../../ui/Carousel";

import AutoScroll from "embla-carousel-auto-scroll";
import { Carousel } from "../../../ui/Carousel";

export const CarouselSection = () => {
  const imgSrcs = [
    "/landing_page_assets/about/About3.png",
    "/landing_page_assets/about/About4.png",
    "/landing_page_assets/about/About5.png",
    "/landing_page_assets/about/About6.png",
    "/landing_page_assets/about/About7.png",
    "/landing_page_assets/about/About8.png",
  ];

  const items = imgSrcs.map((src, idx) => (
    <img
      key={idx}
      src={src}
      alt="placeholder"
      className="tw-aspect-[529/600] tw-h-[450px] tw-w-[353px] tw-rounded-[2em] min1040:tw-h-[600px] min1040:tw-w-[450px]"
    />
  ));

  return (
    <div className="tw-flex tw-h-fit tw-w-[100vw] tw-items-center tw-justify-center">
      <Carousel
        opts={{
          align: "start",
          loop: true,
          slidesToScroll: 1,
          containScroll: "trimSnaps",
          dragFree: true,
          skipSnaps: false,
        }}
        plugins={[
          AutoScroll({
            playOnInit: true,
            stopOnInteraction: true,
            rootNode: (emblaRoot) => emblaRoot.parentElement,
          }),
        ]}
        className="tw-w-full tw-overflow-hidden"
      >
        <CarouselContent className="tw-ml-0 tw-flex tw-items-center tw-justify-start tw-gap-x-[.625em] tw-px-[.625em]">
          {items.concat(items).map((item, idx) => (
            <CarouselItem
              key={idx}
              className="tw-flex tw-w-fit tw-items-center tw-justify-center !tw-pl-[0em] min1040:tw-w-[450px]"
            >
              {item}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
};
